import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

/**
 * Hook unifié pour l'authentification
 * Suit le principe DRY en éliminant la redondance avec useAuthContext
 */
export function useAuth() {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}
